import { parsePrice } from "helpers/price";
import { HorizontalLine } from "pages/Dashboard/components/styled";

import { BenefitLine } from "./BenefitLine";

const coverageColor: any = {
  COVERED: "text-green-500",
  NON_COVERED: "text-red-500",
  UNKNOWN: "text-orange-500",
};

export function ValueNoteSection({
  title,
  items,
  className,
  serviceCoverage,
}: {
  title: string;
  items: {
    Notes?: string | null;
    Value?: string | null;
    subtitle?: string | null;
    additionalCopay?: any | null;
    additionalCoinsurance?: any | null;
  }[];
  className?: string;
  serviceCoverage?: string;
}) {
  if (!items.length) {
    return null;
  }
  return (
    <div className="flex flex-column gap-2">
      {items.map((item, index) => (
        <div
          className="flex flex-column gap-2"
          key={`${title}_${item.subtitle}_${index}`}
        >
          <BenefitLine
            title={`${title} ${item.subtitle || ""}`}
            note={item.Notes}
            value={item.Value}
          />
          <HorizontalLine marginTop="5px" marginBottom="5px" />
          {item?.additionalCopay?.map((copay: any, index: number) => (
            <>
              <BenefitLine
                key={`${index}_additionalCopay`}
                title={`${title} Additional Copay`}
                value={
                  copay.monetaryAmount
                    ? parsePrice(Number(copay.monetaryAmount))
                    : "N/A"
                }
                messages={copay.messages}
                {...(title === "Physician Outpatient" && {
                  networkIndicator: copay.networkIndicator,
                  coverageLevel: copay.coverageLevel,
                  timePeriodQualifier: copay.timePeriodQualifier,
                })}
                benefitEntities={copay.benefitEntities}
              />
              <HorizontalLine marginTop="5px" marginBottom="5px" />
            </>
          ))}
          {item?.additionalCoinsurance?.map(
            (coinsurance: any, index: number) => (
              <>
                <BenefitLine
                  key={`${index}_additionalCoinsurance`}
                  title={`${title} Additional Coinsurance`}
                  value={coinsurance.percent ? `${coinsurance.percent}` : "N/A"}
                  isCoinsurance
                  messages={coinsurance.messages}
                  benefitEntities={coinsurance.benefitEntities}
                  {...(title === "Physician Outpatient" && {
                    networkIndicator: coinsurance.networkIndicator,
                    coverageLevel: coinsurance.coverageLevel,
                    timePeriodQualifier: coinsurance.timePeriodQualifier,
                  })}
                />
                <HorizontalLine marginTop="5px" marginBottom="5px" />
              </>
            )
          )}
        </div>
      ))}
      {serviceCoverage && (
        <p className="text-sm px-4">
          Service Coverage:{" "}
          <span className={coverageColor[serviceCoverage]}>
            {serviceCoverage === "NON_COVERED"
              ? "NON COVERED"
              : serviceCoverage}
          </span>
        </p>
      )}
    </div>
  );
}
